export const resourcesAR = {
    Home: "هوم",
    Services: "سيرفيسز",
    Contact: "كونتاكت",
    About: "اباوت",
    Submit: "سابميت",
    SocialMedia: "سوشال ميديا",
    CreatedBY: "كرييتد باي",
    Main: "رئيسي",
    Industries: "الصناعات"
};
